import * as React from 'react';
import { ProgramDetailResource } from '../../../ProgramStore/Types';
import { Position } from '../../PositionContext';
import TeamMembers from './TeamMembers';
import TeamsSummary from './TeamsSummary';

interface Props {
  programDetailResource: ProgramDetailResource;
  position: Position;
}

const TeamsRendererImpl: React.FC<Props> = ({ programDetailResource, position }) => {
  switch (position.kind) {
    case 'overview':
      return <TeamMembers programDetailResource={programDetailResource} />;
    case 'nav':
    case 'dashboard':
    case 'tooltip':
    case 'supPanel':
    case 'chat':
    case 'participant':
    case 'footer':
    case 'none':
      return <TeamsSummary programDetailResource={programDetailResource} />;
  }
};

export default TeamsRendererImpl;
